import { publicClientFetcher } from "./client-fetcher";
import type { TrainingSessionData, TrainingParams } from "@workspace/types";

/**
 * Create a new public training session
 */
export const createPublicTrainingSession = async (
  params: TrainingParams,
): Promise<TrainingSessionData> => {
  return (
    await publicClientFetcher.post("/public/training-sessions", {
      training_scenario_type: params.scenarioType,
    })
  ).data;
};

/**
 * Get training session details (for polling feedback)
 */
export const getPublicTrainingSession = async (
  sessionId: string,
): Promise<TrainingSessionData> => {
  return (
    await publicClientFetcher.get(`/public/training-sessions/${sessionId}`)
  ).data;
};

/**
 * Mark training session as complete
 */
export const completePublicTrainingSession = async (
  sessionId: string,
): Promise<TrainingSessionData> => {
  return (
    await publicClientFetcher.post(
      `/public/training-sessions/${sessionId}/complete`,
    )
  ).data;
};
